import { render, staticRenderFns } from "./LogoAnimated.vue?vue&type=template&id=05dcf59b&scoped=true&"
var script = {}
import style0 from "./LogoAnimated.vue?vue&type=style&index=0&id=05dcf59b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dcf59b",
  null
  
)

export default component.exports